const namespaced = true

const getters = {
  busy: (_s, _g, _r, rootGetters) => {
    return rootGetters['files/busy'] ||
      rootGetters['filesFolder/folderBusy'] ||
      rootGetters['filesRecent/recentBusy'] ||
      rootGetters['filesMedia/mediaBusy']
  }
}

export default {
  namespaced,
  getters
}
